/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithCustomerNumberItemRequestBuilder, WithCustomerNumberItemRequestBuilderNavigationMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v1/organizations/{organizationId}/customers
 */
export interface CustomersRequestBuilder extends BaseRequestBuilder<CustomersRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.v1.organizations.item.customers.item collection
     * @param customerNumber Unique identifier of the item
     * @returns {WithCustomerNumberItemRequestBuilder}
     */
     byCustomerNumber(customerNumber: string) : WithCustomerNumberItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CustomersRequestBuilderUriTemplate = "{+baseurl}/api/v1/organizations/{organizationId}/customers";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CustomersRequestBuilderNavigationMetadata: Record<Exclude<keyof CustomersRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCustomerNumber: {
        navigationMetadata: WithCustomerNumberItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["customerNumber"],
    },
};
/* tslint:enable */
/* eslint-enable */
